/*=========================================================================================
  File Name: globalComponents.js
  Description: Here you can register components globally
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import VueFormGenerator from "vue-form-generator/dist/vfg-core.js";
import VxTooltip from './layouts/components/vx-tooltip/VxTooltip.vue'
import VxCard  from './components/vx-card/VxCard.vue'
import VxList  from './components/vx-list/VxList.vue'
import VxBreadcrumb  from './layouts/components/VxBreadcrumb.vue'
import FeatherIcon  from './components/FeatherIcon.vue'
import VxInputGroup  from './components/vx-input-group/VxInputGroup.vue'
import VsCurrency from "@/components/custom-form/vfg-vscurrency";
import VsInput from "@/components/custom-form/vfg-vsinput";
import VsSwitch from "@/components/custom-form/vfg-vsswitch";
import VsSelect from "@/components/custom-form/vfg-vsselect";
import VsNumber from "@/components/custom-form/vfg-vsnumber";
import VsDatePicker from "@/components/custom-form/vfg-vsdatepicker";
import VsTextArea from "@/components/custom-form/vfg-vstextarea";
import VsPassword from "@/components/custom-form/vfg-vspassword";

import GenericTable from "@/components/GenericTable";

Vue.component(VxTooltip.name, VxTooltip)
Vue.component(VxCard.name, VxCard)
Vue.component(VxList.name, VxList)
Vue.component(VxBreadcrumb.name, VxBreadcrumb)
Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(VxInputGroup.name, VxInputGroup)

Vue.use(VueFormGenerator);
Vue.component("field-vscurrency", VsCurrency);
Vue.component("field-vsinput", VsInput);
Vue.component("field-vsswitch", VsSwitch);
Vue.component("field-vsselect", VsSelect);
Vue.component("field-vsnumber", VsNumber);
Vue.component("field-vsdatepicker", VsDatePicker);
Vue.component("field-vstextarea", VsTextArea);
Vue.component("field-vspassword", VsPassword);

Vue.component("generic-table", GenericTable);


// v-select component
import vSelect from 'vue-select'

// Set the components prop default to return our fresh components
vSelect.props.components.default = () => ({
  Deselect: {
    render: createElement => createElement('feather-icon', {
      props: {
        icon: 'XIcon',
        svgClasses: 'w-4 h-4 mt-1'
      }
    }),
  },
  OpenIndicator: {
    render: createElement => createElement('feather-icon', {
      props: {
        icon: 'ChevronDownIcon',
        svgClasses: 'w-5 h-5'
      }
    }),
  },
});

Vue.component(vSelect)
